import { PNP_TRUSTLY_DECLINED_REASONS } from './constants.ts';

const R = PNP_TRUSTLY_DECLINED_REASONS;

const DECLINED_REASON_BY_CODE: Record<string, string> = {
  unique_player:      R.UNIQUE_PLAYER,
  multiple_pno_usage: R.UNIQUE_PLAYER,
  player_not_matched: R.UNIQUE_PLAYER,
  credentials_taken:  R.UNIQUE_PLAYER,

  account_blocked:            R.ACCOUNT_BLOCKED,
  player_matched_but_blocked: R.ACCOUNT_BLOCKED,

  pnp_deposit_limit_reached: R.PNP_DEPOSIT_LIMIT_REACHED,
  money_limit_exceeded:      R.PNP_DEPOSIT_LIMIT_REACHED,

  id_verification_failed: R.ID_VERIFICATION_FAILED,
  invalid_identity:       R.ID_VERIFICATION_FAILED,
  kyc_required:           R.ID_VERIFICATION_FAILED,

  user_under_age: R.USER_UNDER_AGE,
  too_young:      R.USER_UNDER_AGE,

  unsupported_country_code: R.UNSUPPORTED_COUNTRY_CODE,
  country_restricted:       R.UNSUPPORTED_COUNTRY_CODE,

  '27':                     R.PNP_DEPOSIT_UNSUCCESSFUL,
  pnp_deposit_unsuccessful: R.PNP_DEPOSIT_UNSUCCESSFUL,
  piq_payment_failed:       R.PNP_DEPOSIT_UNSUCCESSFUL,
  base_error:               R.PNP_DEPOSIT_UNSUCCESSFUL,
  insufficient_balance:     R.PNP_DEPOSIT_UNSUCCESSFUL,

  registration_timeout:   R.REGISTRATION_TIMED_OUT,
  registration_timed_out: R.REGISTRATION_TIMED_OUT,

  transaction_refunded:   R.TRANSACTION_REFUNDED,
  piq_transaction_refund: R.TRANSACTION_REFUNDED,

  user_canceled: R.USER_CANCELED,
};

export const resolveDeclinedReason = (code?: string): string => {
  const key = String(code ?? '').trim().toLowerCase();
  if (!key) return R.PNP_DEPOSIT_UNSUCCESSFUL;

  return DECLINED_REASON_BY_CODE[key] ?? key;
};
